import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "@mui/material";
import FeatherIcon from "feather-icons-react";

import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
} from "@components/base";

const Buttons: FC = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack spacing={4}>
      <Typography variant="h2">{t("buttons.title")}</Typography>
      <FormControlLabel
        value={isLoading}
        control={<Switch />}
        onChange={() => setIsLoading(!isLoading)}
        label={t("buttons.isLoading")}
      />
      <Divider />
      <Stack spacing={2}>
        <Typography variant="subtitle1">
          {t("buttons.contained.subtitle")}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button size="large" isLoading={isLoading}>
              {t("buttons.contained.large")}
            </Button>
          </Box>
          <Box>
            <Button size="medium" isLoading={isLoading}>
              {t("buttons.contained.medium")}
            </Button>
          </Box>
          <Box>
            <Button size="small" isLoading={isLoading}>
              {t("buttons.contained.small")}
            </Button>
          </Box>
          <Box>
            <Button size="extraSmall" isLoading={isLoading}>
              {t("buttons.contained.extraSmall")}
            </Button>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button
              size="large"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.contained.large")}
            </Button>
          </Box>
          <Box>
            <Button
              size="medium"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.contained.medium")}
            </Button>
          </Box>
          <Box>
            <Button
              size="small"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.contained.small")}
            </Button>
          </Box>
          <Box>
            <Button
              size="extraSmall"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.contained.extraSmall")}
            </Button>
          </Box>
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={2}>
        <Typography variant="subtitle1">{t("buttons.outlined.subtitle")}</Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button variant="outlined" size="large" isLoading={isLoading}>
              {t("buttons.outlined.large")}
            </Button>
          </Box>
          <Box>
            <Button variant="outlined" size="medium" isLoading={isLoading}>
              {t("buttons.outlined.medium")}
            </Button>
          </Box>
          <Box>
            <Button variant="outlined" size="small" isLoading={isLoading}>
              {t("buttons.outlined.small")}
            </Button>
          </Box>
          <Box>
            <Button variant="outlined" size="extraSmall" isLoading={isLoading}>
              {t("buttons.outlined.extraSmall")}
            </Button>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button
              variant="outlined"
              size="large"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.outlined.large")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              size="medium"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.outlined.medium")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.outlined.small")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              size="extraSmall"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.outlined.extraSmall")}
            </Button>
          </Box>
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={2}>
        <Typography variant="subtitle1">{t("buttons.text.subtitle")}</Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button variant="text" size="large" isLoading={isLoading}>
              {t("buttons.text.large")}
            </Button>
          </Box>
          <Box>
            <Button variant="text" size="medium" isLoading={isLoading}>
              {t("buttons.text.medium")}
            </Button>
          </Box>
          <Box>
            <Button variant="text" size="small" isLoading={isLoading}>
              {t("buttons.text.small")}
            </Button>
          </Box>
          <Box>
            <Button variant="text" size="extraSmall" isLoading={isLoading}>
              {t("buttons.text.extraSmall")}
            </Button>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button
              variant="text"
              size="large"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.text.large")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="text"
              size="medium"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.text.medium")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="text"
              size="small"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.text.small")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="text"
              size="extraSmall"
              startIcon={<FeatherIcon icon="download" />}
              isLoading={isLoading}
            >
              {t("buttons.text.extraSmall")}
            </Button>
          </Box>
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={2}>
        <Typography variant="subtitle1">
          {t("buttons.containedError.subtitle")}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button size="large" color="error" isLoading={isLoading}>
              {t("buttons.containedError.large")}
            </Button>
          </Box>
          <Box>
            <Button size="medium" color="error" isLoading={isLoading}>
              {t("buttons.containedError.medium")}
            </Button>
          </Box>
          <Box>
            <Button size="small" color="error" isLoading={isLoading}>
              {t("buttons.containedError.small")}
            </Button>
          </Box>
          <Box>
            <Button size="extraSmall" color="error" isLoading={isLoading}>
              {t("buttons.containedError.extraSmall")}
            </Button>
          </Box>
        </Stack>
        <Typography variant="subtitle1">
          {t("buttons.outlinedError.subtitle")}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button
              variant="outlined"
              size="large"
              color="error"
              isLoading={isLoading}
            >
              {t("buttons.outlinedError.large")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              size="medium"
              color="error"
              isLoading={isLoading}
            >
              {t("buttons.outlinedError.medium")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              size="small"
              color="error"
              isLoading={isLoading}
            >
              {t("buttons.outlinedError.small")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              size="extraSmall"
              color="error"
              isLoading={isLoading}
            >
              {t("buttons.outlinedError.extraSmall")}
            </Button>
          </Box>
        </Stack>
        <Typography variant="subtitle1">
          {t("buttons.textError.subtitle")}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Box>
            <Button variant="text" size="large" color="error" isLoading={isLoading}>
              {t("buttons.textError.large")}
            </Button>
          </Box>
          <Box>
            <Button variant="text" size="medium" color="error" isLoading={isLoading}>
              {t("buttons.textError.medium")}
            </Button>
          </Box>
          <Box>
            <Button variant="text" size="small" color="error" isLoading={isLoading}>
              {t("buttons.textError.small")}
            </Button>
          </Box>
          <Box>
            <Button
              variant="text"
              size="extraSmall"
              color="error"
              isLoading={isLoading}
            >
              {t("buttons.textError.extraSmall")}
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Buttons;
